import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ANALYTICS_GTM_ENABLED } from 'constants/analytics';
import { decorateWith, withName } from 'helpers/decorator';
import { getCookie } from 'redux/saga/helpers/cookies';
import { readLocalStorage } from 'redux/saga/helpers/local-storage';
import { dashFeatureById } from 'redux/saga/entities/bound';

const GTM_INIT = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM_CONTAINER_ID');`;

// This lives outside of the component so it can be used in places that are
// not in the component hierarchy (such as sagas).
export const trackGoogleTagManagerEvent = data => {
  /* istanbul ignore next */
  if (__CLIENT__ || __TEST__) {
    if (readLocalStorage('trackingDebug')) {
      console.info('Tracking GTM', data); // eslint-disable-line no-console
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    const loc = document.location;
    window.dataLayer.push({
      originalLocation: `${loc.protocol}//${loc.hostname}${loc.pathname}${loc.search}`,
    });
  }
};

export class GoogleTagManagerUnwrapped extends Component {
  componentDidMount() {
    const cpUserType = getCookie('cpUserType') || 'prospect';
    trackGoogleTagManagerEvent({ userType: cpUserType });
  }

  componentDidUpdate(prevProps) {
    const { userId } = this.props;

    if (!prevProps.userId && userId) {
      trackGoogleTagManagerEvent({ userId: String(userId) });
    }
  }

  createTagEventProperties() {
    const { glsLocationId, userId } = this.props;
    const properties = {
      glsLocationId,
      userId,
    };

    const filteredProperties = Object.keys(properties).reduce((result, key) => {
      if (properties[key] !== undefined) {
        result[key] = String(properties[key]);
      }

      return result;
    }, {});

    return filteredProperties;
  }

  render() {
    const { containerId, enableGtm } = this.props;

    if (!enableGtm) {
      return null;
    }

    const eventProperties = this.createTagEventProperties();

    if (Object.keys(eventProperties).length > 0) {
      trackGoogleTagManagerEvent(eventProperties);
    }

    const code = GTM_INIT.replace(/GTM_CONTAINER_ID/, containerId);

    return (
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: code }}
      />
    );
  }
}

GoogleTagManagerUnwrapped.propTypes = {
  containerId: PropTypes.string.isRequired,
  enableGtm: PropTypes.bool,
  userId: PropTypes.number,
  glsLocationId: PropTypes.number,
};

const mapStateToProps = state => ({
  enableGtm: dashFeatureById.data(state, ANALYTICS_GTM_ENABLED),
});

export const GoogleTagManager = decorateWith(connect(mapStateToProps), withName('GoogleTagManager'))(
  GoogleTagManagerUnwrapped
);
